/**
 * GULP Skin — Scroll Reveal Animations
 * Uses IntersectionObserver to trigger CSS animations as elements enter viewport.
 * Respects prefers-reduced-motion.
 */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var THRESHOLD = 0.12;
  var ROOT_MARGIN = '0px 0px -40px 0px';

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('gulp-revealed');
        observer.unobserve(entry.target);
      }
    });
  }, {
    threshold: THRESHOLD,
    rootMargin: ROOT_MARGIN
  });

  function init() {
    // Sections to reveal
    var selectors = [
      '.section-collection .grid__item',
      '.section-collection .product-grid-item',
      '.section-newsletter',
      '.section-rich-text',
      '.image-with-text',
      '.section-testimonials',
      '.section-icons-row .icons-row__item',
      '.section-blog-posts .blog-posts__item',
      '.section-image-with-text-split',
      '.section-promotion-row .grid__item',
      '.banner-image__content',
      '.section-marquee',
    ].join(', ');

    document.querySelectorAll(selectors).forEach(function (el, i) {
      // Stagger siblings within the same parent
      var siblings = el.parentElement ? el.parentElement.querySelectorAll('[class]') : [];
      var siblingIndex = Array.prototype.indexOf.call(siblings, el);
      if (siblingIndex > 0) {
        el.style.transitionDelay = Math.min(siblingIndex * 80, 400) + 'ms';
      }
      el.classList.add('gulp-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
